// Remove these utils with Bug 131273: Remove OWS to REST ID and vice versa Id conversion logic once platform provides support.
export function translateRestIdToOwsId(id: string): string {
    return id.split('-').join('/').split('_').join('+');
}
